import React, { Component } from 'react';
import { server } from '../redux/sagas'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

class AwardImage extends Component {
    componentDidMount() {
        this.updateCanvas();
    }
    updateCanvas() {
        function pad(num, size) {
            let s = num+"";
            while (s.length < size) s = "0" + s;
            return s;
        }

        const award = this.refs.canvas.getContext('2d');
        let image = new Image(50, 15);
        let level = new Image(50, 15);
        image.src = this.props.award.image.image;
        image.addEventListener('load', function() {
            award.drawImage(image, 0, 0);
        }, false);

        level.src = server+"/media/images/devices/"+pad(this.props.level,3)+".png";
        level.addEventListener('load', function() {
            award.drawImage(level, 0, 0);
        }, false);
    }

    render() {
        return (
            <OverlayTrigger placement="top" overlay={<Tooltip id="created-tooltip">{this.props.award.title} level {this.props.level}</Tooltip>}>
                <canvas ref="canvas" width={50} height={15}/>
            </OverlayTrigger>
        )
    }
}

export default AwardImage;


// WEBPACK FOOTER //
// ./src/Awards/AwardImage.js